import { render, staticRenderFns } from "./LodJoinFacility.vue?vue&type=template&id=0042bf1c&scoped=true"
import script from "./LodJoinFacility.vue?vue&type=script&lang=js"
export * from "./LodJoinFacility.vue?vue&type=script&lang=js"
import style0 from "./LodJoinFacility.vue?vue&type=style&index=0&id=0042bf1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0042bf1c",
  null
  
)

export default component.exports